import { SttChunkState } from '@ftr/contracts/regional-api/stt'
import { isSameWithinTolerance } from '@ftr/foundation'
import { LocalDateTime } from '@js-joda/core'
import { SttRemark } from '../../../types'

export function chunkToRemark(sttChunk: SttChunkState): SttRemark {
  return {
    status: sttChunk.status,
    startTime: sttChunk.startTime,
    endTime: sttChunk.endTime,
  }
}

export function chunkStateStatusReducer(mergedChunks: SttChunkState[], currentChunk: SttChunkState): SttChunkState[] {
  const previousChunk = mergedChunks[mergedChunks.length - 1]
  if (
    previousChunk &&
    chunksHaveSameStatus(previousChunk, currentChunk) &&
    chunksAreContinuous(previousChunk, currentChunk)
  ) {
    previousChunk.endTime = currentChunk.endTime
    return mergedChunks
  }

  mergedChunks.push({ ...currentChunk })
  return mergedChunks
}

function chunksHaveSameStatus(a: SttChunkState, b: SttChunkState): boolean {
  return a.status === b.status
}

/**
 * Use TRM tolerance that is the same as defined in Regional API [1].
 *
 * [1]: GitHub source link https://bit.ly/3bvkNXx
 */
const TRM_TOLERANCE = 1

function chunksAreContinuous(a: SttChunkState, b: SttChunkState): boolean {
  return isSameWithinTolerance(b.startTime, a.endTime, TRM_TOLERANCE)
}

export function chunkToChunkWithLocalDateTime(chunk: SttChunkState): SttChunkState {
  return {
    ...chunk,
    startTime: LocalDateTime.parse(chunk.startTime.toString()),
    endTime: LocalDateTime.parse(chunk.endTime.toString()),
  }
}
